import React from "react";
import { Box, Stack, Button, Typography } from "@mui/material";
import { tabComponentMap } from "../../helpers/tabs-mapping";

const BlankShippingCase = ({
  type,
  init,
  text,
  subtext,
  buttonText,
  isPermitted = true,
}: {
  isPermitted: boolean;
  text: string;
  subtext: string;
  type: string;
  buttonText?: string;
  init?: () => void;
}) => {
  return (
    <Stack textAlign="center" p={7} gap={1}>
      <Typography variant="subtitle1" fontSize="16px">
        {text}
      </Typography>
      {isPermitted && (
        <Typography
          variant="body2"
          color="rgba(0, 0, 0, 0.6)"
          sx={{ whiteSpace: "pre-line" }}
        >
          {subtext}
        </Typography>
      )}

      {init && isPermitted && (
        <Box mt={1}>
          <Button variant="contained" onClick={() => init()}>
            {buttonText ?? `Add ${tabComponentMap[type].button}`}
          </Button>
        </Box>
      )}
    </Stack>
  );
};
export default BlankShippingCase;
